/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StakeholderBenchmarkCustomItemPaginationSlice', 'model/StakeholderBenchmarkDimensionReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StakeholderBenchmarkCustomItemPaginationSlice'), require('./StakeholderBenchmarkDimensionReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderBenchmarkReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StakeholderBenchmarkCustomItemPaginationSlice, root.ForStractionServiceApi.StakeholderBenchmarkDimensionReportPaginationSlice);
  }
}(this, function(ApiClient, StakeholderBenchmarkCustomItemPaginationSlice, StakeholderBenchmarkDimensionReportPaginationSlice) {
  'use strict';




  /**
   * The StakeholderBenchmarkReport model module.
   * @module model/StakeholderBenchmarkReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StakeholderBenchmarkReport</code>.
   * @alias module:model/StakeholderBenchmarkReport
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>StakeholderBenchmarkReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StakeholderBenchmarkReport} obj Optional instance to populate.
   * @return {module:model/StakeholderBenchmarkReport} The populated <code>StakeholderBenchmarkReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimensions')) {
        obj['Dimensions'] = StakeholderBenchmarkDimensionReportPaginationSlice.constructFromObject(data['Dimensions']);
      }
      if (data.hasOwnProperty('Items')) {
        obj['Items'] = StakeholderBenchmarkCustomItemPaginationSlice.constructFromObject(data['Items']);
      }
      if (data.hasOwnProperty('GroupID')) {
        obj['GroupID'] = ApiClient.convertToType(data['GroupID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('MinText')) {
        obj['MinText'] = ApiClient.convertToType(data['MinText'], 'String');
      }
      if (data.hasOwnProperty('MaxText')) {
        obj['MaxText'] = ApiClient.convertToType(data['MaxText'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ShowCurrentCompany')) {
        obj['ShowCurrentCompany'] = ApiClient.convertToType(data['ShowCurrentCompany'], 'Boolean');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} TypeID
   */
  exports.prototype['TypeID'] = undefined;
  /**
   * @member {module:model/StakeholderBenchmarkDimensionReportPaginationSlice} Dimensions
   */
  exports.prototype['Dimensions'] = undefined;
  /**
   * @member {module:model/StakeholderBenchmarkCustomItemPaginationSlice} Items
   */
  exports.prototype['Items'] = undefined;
  /**
   * @member {Integer} GroupID
   */
  exports.prototype['GroupID'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} MinText
   * @default ''
   */
  exports.prototype['MinText'] = '';
  /**
   * @member {String} MaxText
   * @default ''
   */
  exports.prototype['MaxText'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Boolean} ShowCurrentCompany
   * @default false
   */
  exports.prototype['ShowCurrentCompany'] = false;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


